import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';

function PaymentsSuccess() {
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('Finalising your payment…');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const paymentIntentId = searchParams.get('payment_intent');
    const redirectStatus = searchParams.get('redirect_status');

    if (!paymentIntentId) {
      setStatus('error');
      setMessage('Missing payment details from Stripe.');
      return;
    }

    if (redirectStatus === 'succeeded') {
      setStatus('success');
      setMessage('Your rent payment was successful!');

      // After a short pause, redirect back to the payments page
      const t = setTimeout(() => {
        navigate('/tenant-portal');
      }, 1500);

      return () => clearTimeout(t);
    }

    // Any other redirect status is considered an error
    setStatus('error');
    setMessage('Your payment could not be confirmed. Please try again.');
  }, [searchParams, navigate]);

  const isLoading = status === 'loading';
  const isError = status === 'error';
  const isSuccess = status === 'success';

  return (
    <div className="pt-10 md:pt-0 text-white relative">
      <div className="max-w-xl mx-auto mt-16 p-8 bg-white/10 border border-white/10 rounded-2xl backdrop-blur-md text-center">

        {isLoading && (
          <>
            <p className="text-lg font-semibold mb-2">Finalising your payment…</p>
            <p className="text-gray-300 text-sm">{message}</p>
          </>
        )}

        {isSuccess && (
          <>
            <div className="flex justify-center mb-4">
              <CheckCircle className="w-12 h-12 text-green-400" />
            </div>
            <p className="text-xl font-semibold mb-2">Payment successful 🎉</p>
            <p className="text-gray-300 text-sm">
              Redirecting you back to your tenant portal…
            </p>
          </>
        )}

        {isError && (
          <>
            <div className="flex justify-center mb-4">
              <XCircle className="w-12 h-12 text-red-400" />
            </div>
            <p className="text-xl font-semibold mb-2">Something went wrong</p>
            <p className="text-gray-300 text-sm mb-4">{message}</p>
            <button
              onClick={() => navigate('/payments')}
              className="px-4 py-2 rounded-xl bg-white/10 hover:bg-[#AF9B8A]/20 transition"
            >
              Back to payments
            </button>
          </>
        )}

      </div>
    </div>
  );
}

export default PaymentsSuccess;
